import Vue from 'vue';
import { VueServerRequest } from '@nutshell/vue';

Vue.use(VueServerRequest);

const xhr = new VueServerRequest();

//Specifiek voor Laravel
let parentPost = xhr.instance.post;
xhr.instance.put = (function(target, data, options, files, headers) {
	data['_method'] = 'PUT';
	return parentPost.apply(this, arguments);
});

//Specifiek voor Laravel
let parentSend = xhr.instance.send;
xhr.instance.send = (function() {
	return parentSend.apply(this, arguments).catch(result => {
		console.log(result);
		if (result.status == 419) {
			location.reload();
		}
		throw result;
	} );
})

export default xhr;

/*
---
name: XML Http Request
category: Application
subcategory: Vue
---

Adding the ServerRequest from @nutshell/core to your Vue project. Your ServerRequest is now available as this.$xhr in all Vue components.

```js
import Vue from 'vue';
import { VueServerRequest } from '@nutshell/vue';

Vue.use(VueServerRequest);

const xhr = new VueServerRequest();

//Adding the socket to the vue instance
const app = new Vue({
	router,
	store,
	socket,
    xhr,
	render: h => h(App)
}).$mount(AppConfig.mount || '#application');

```

```js
//usage Examples
<script>
export default {
	mounted() {

		this.$xhr.post('method', {example: 'test'}).then( ( {result} ) => {
			//Do success action
		}).catch( () => {
			//Do error
		});
	}
}
</script>
```
*/
